const Features = {
    SCHEDULED_SESSIONS: 'SCHEDULED_SESSIONS',
    LOAD_PLAN: 'LOAD_PLAN',
    FREEZE_PLAN: 'FREEZE_PLAN',
    GLOBAL_ACCOUNTING: 'GLOBAL_ACCOUNTING',
    REGISTER_TRANSACTION: 'REGISTER_TRANSACTION',
    ACCOUNTING_CLOSE: 'ACCOUNTING_CLOSE',
    ACCOUNTING_DETAILS: 'ACCOUNTING_DETAILS',
    SALES_VIEW: 'SALES_VIEW',
    STATISTICS_VIEW: 'STATISTICS_VIEW',
    USERS_VIEW: 'USERS_VIEW',
    HOURS_TO_CANCEL: 'HOURS_TO_CANCEL',
    PENALIZATION: 'PENALIZATION',
    ACHIEVEMENTS: 'ACHIEVEMENTS',
    AGREEMENTS: 'AGREEMENTS',
    RANKING: 'RANKING',
    VIRTUAL_TRAININGS: 'VIRTUAL_TRAININGS',
    CHECK_ATTENDANCE: 'CHECK_ATTENDANCE',
    TAMAGOTCHI: 'TAMAGOTCHI',
    COURTESIES_VIEW: 'COURTESIES_VIEW',
    SEE_PAST_EVENTS: 'SEE_PAST_EVENTS',
    PCC: 'PCC',
    SEE_PCC: 'SEE_PCC',
    LIFE_TIME_VALUE: 'LIFE_TIME_VALUE',
    RETENTION: 'RETENTION',
    CANCEL_OTHER_CLASSES: 'CANCEL_OTHER_CLASSES',
    FREEZE_INDEFINITELY: 'FREEZE_INDEFINITELY',
    MEMBERSHIP_STATS: 'MEMBERSHIP_STATS',
    CANCEL_SUBSCRIPTION: 'CANCEL_SUBSCRIPTION',
    USERS_BASIC_INFO: 'USERS_BASIC_INFO',
    USERS_SENSITIVE_INFO: 'USERS_SENSITIVE_INFO',
    SEE_OTHERS_CURRENT_PLAN: 'SEE_OTHERS_CURRENT_PLAN',
    SEE_OTHERS_SUBSCRIPTION: 'SEE_OTHERS_SUBSCRIPTION',
    COLLECT_PAYMENT: 'COLLECT_PAYMENT',
    YEAR_WRAPPED: 'YEAR_WRAPPED',
    COURTESIES_STATS: 'COURTESIES_STATS',
    SESSION_MILESTONES: 'SESSION_MILESTONES',
    ADMIN_USER_EDITION: 'ADMIN_USER_EDITION',
    CRM: 'CRM',
    INTERNAL_CHATBOT: 'INTERNAL_CHATBOT',
  };
  
  export default Features;
  